import { Component, OnInit } from '@angular/core';
import { SectionBreakFormControl } from './section-break.control';

@Component({
  selector: 'app-bs-app-launch-section-break-control',
  templateUrl: './bs-app-launch-section-break-control.component.html',
  styleUrls: ['./bs-app-launch-section-break-control.component.scss']
})
export class BsAppLaunchSectionBreakControlComponent implements OnInit {
  formControl: SectionBreakFormControl;

  constructor() { }

  ngOnInit() {
  }

}
